(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["helix-peptide-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseCalculators = () => {
      document.querySelectorAll('[data-hpc-root]').forEach((root) => {
        if (root.dataset.hpcReady === 'true') return;
        root.dataset.hpcReady = 'true';

        const form = root.querySelector('[data-hpc-form]');
        const strengthInput = root.querySelector('[data-hpc-strength]');
        const waterInput = root.querySelector('[data-hpc-water]');
        const targetInput = root.querySelector('[data-hpc-target]');
        const targetUnitInput = root.querySelector('[data-hpc-target-unit]');
        const syringeInput = root.querySelector('[data-hpc-syringe]');
        const resetButton = root.querySelector('[data-hpc-reset]');
        const status = root.querySelector('[data-hpc-status]');

        const output = {
          units: root.querySelector('[data-hpc-units]'),
          volume: root.querySelector('[data-hpc-volume]'),
          concentration: root.querySelector('[data-hpc-concentration]'),
          target: root.querySelector('[data-hpc-target-display]'),
          capacity: root.querySelector('[data-hpc-capacity-display]'),
          barrel: root.querySelector('[data-hpc-barrel-value]'),
          liquid: root.querySelector('[data-hpc-liquid]'),
          scaleQuarter: root.querySelector('[data-hpc-quarter]'),
          scaleHalf: root.querySelector('[data-hpc-half]'),
          scaleThreeQuarter: root.querySelector('[data-hpc-three-quarter]'),
          scaleCapacity: root.querySelector('[data-hpc-capacity]')
        };

        const number = (value) => Number.parseFloat(value);
        const format = (value, maxDecimals = 3) => new Intl.NumberFormat('en-GB', {
          maximumFractionDigits: maxDecimals,
          minimumFractionDigits: 0
        }).format(value);
        const formatPrecise = (value) => {
          if (value === 0) return '0';
          if (Math.abs(value) < 0.001) return value.toExponential(2);
          return format(value, value < 1 ? 4 : 2);
        };

        const setStatus = (message, state = 'ok') => {
          status.textContent = message;
          status.dataset.state = state;
        };

        const setScale = (capacity) => {
          output.scaleQuarter.textContent = format(capacity * 0.25, 1);
          output.scaleHalf.textContent = format(capacity * 0.5, 1);
          output.scaleThreeQuarter.textContent = format(capacity * 0.75, 1);
          output.scaleCapacity.textContent = `${format(capacity, 0)} units`;
          output.capacity.textContent = `${format(capacity, 0)} units`;
        };

        const calculate = () => {
          const strengthMg = number(strengthInput.value);
          const waterMl = number(waterInput.value);
          const targetEntered = number(targetInput.value);
          const capacity = number(syringeInput.value);
          const targetMcg = targetUnitInput.value === 'mg' ? targetEntered * 1000 : targetEntered;

          setScale(capacity);

          if (![strengthMg, waterMl, targetEntered, capacity].every(Number.isFinite)) {
            setStatus('Please complete every field using numbers only.', 'error');
            return;
          }
          if (strengthMg <= 0 || waterMl <= 0 || targetEntered <= 0) {
            setStatus('Every amount must be greater than zero.', 'error');
            return;
          }

          const vialMcg = strengthMg * 1000;
          const concentration = vialMcg / waterMl;
          const volumeMl = targetMcg / concentration;
          const units = volumeMl * 100;
          const fillPercent = Math.min(Math.max((units / capacity) * 100, 0), 100);

          output.units.textContent = formatPrecise(units);
          output.volume.textContent = `${formatPrecise(volumeMl)} mL`;
          output.concentration.textContent = `${format(concentration, 2)} mcg/mL`;
          output.target.textContent = `${formatPrecise(targetEntered)} ${targetUnitInput.value}`;
          output.barrel.textContent = `${formatPrecise(units)} units`;
          output.liquid.style.width = `${fillPercent}%`;

          if (targetMcg > vialMcg) {
            setStatus('Warning: the chosen target amount is larger than the total amount entered for the vial. Recheck the figures.', 'error');
          } else if (units > capacity) {
            setStatus(`Warning: ${formatPrecise(units)} units is larger than the selected ${format(capacity, 0)}-unit capacity. Recheck the inputs and equipment.`, 'error');
          } else if (units < 1) {
            setStatus('The result is below 1 U-100 unit. A physical device may not have markings precise enough to display this value.', 'error');
          } else {
            setStatus('Calculation complete. Independently verify every input, unit and equipment marking before relying on this result.');
          }
        };

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          calculate();
        });

        syringeInput.addEventListener('change', calculate);
        targetUnitInput.addEventListener('change', calculate);
        [strengthInput, waterInput, targetInput].forEach((input) => {
          input.addEventListener('change', calculate);
        });
        resetButton.addEventListener('click', () => {
          form.reset();
          calculate();
          strengthInput.focus();
        });

        calculate();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseCalculators);
    } else {
      initialiseCalculators();
    }

    document.addEventListener('shopify:section:load', initialiseCalculators);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
